module.exports = __webpack_public_path__ + "static/media/65.f81772c3.gif";